/**
 * Dashboards Overview constants
 */

/**
 * Dashboard type values from backend/Typesense
 * These correspond to the DashboardType field in the dashboards collection with "Template" deliberately excluded
 * since we do not want the users to be able to filter by or facet on templates in the Dashboards Overview page.
 */
export const DASHBOARD_TYPES = ['User', 'System'] as const;

/**
 * Sharing scope values from backend/Typesense
 * These correspond to the SharingScope field in the dashboards collection
 */
export const SHARING_SCOPES = [
  'Private',
  'Department',
  'LegalEntity',
  'Tenant',
] as const;

export const DASHBOARD_ID_PARAMETER_NAME = 'dashboard-id';
